import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { ContainerStoryblok } from "@/types/blok-types";
import { SbBlokData, storyblokEditable } from "@storyblok/js";
import clsx from "clsx";
import { ComponentProps } from "react";
import styles from "./index.module.css";

export interface ContainerProps extends ComponentProps<"div"> {
  blok: ContainerStoryblok;
  preview?: boolean;
}

export const Container = ({
  blok,
  className,
  preview,
  ...rest
}: ContainerProps) => {
  return (
    <div
      data-layout="blok"
      data-container="small"
      {...storyblokEditable(blok as SbBlokData)}
      className={clsx(styles.container, className)}
      {...rest}
    >
      {blok.content?.map((c) => (
        <StoryblokComponent preview={preview} blok={c} key={c._uid} />
      ))}
    </div>
  );
};
